__turbopack_context__.v({
  "changeSummary": "_4SDRpW_changeSummary",
  "dueStatusOverdue": "_4SDRpW_dueStatusOverdue",
  "entityCell": "_4SDRpW_entityCell",
  "entityMeta": "_4SDRpW_entityMeta",
  "entityName": "_4SDRpW_entityName",
  "meterCell": "_4SDRpW_meterCell",
  "meterMeta": "_4SDRpW_meterMeta",
  "metricsGrid": "_4SDRpW_metricsGrid",
  "performanceLoading": "_4SDRpW_performanceLoading",
  "performancePage": "_4SDRpW_performancePage",
  "performanceSection": "_4SDRpW_performanceSection",
  "performanceTopBar": "_4SDRpW_performanceTopBar",
  "sectionHeader": "_4SDRpW_sectionHeader",
  "sectionSubtitle": "_4SDRpW_sectionSubtitle",
  "sectionTitle": "_4SDRpW_sectionTitle",
  "tableNote": "_4SDRpW_tableNote",
  "totalsLabel": "_4SDRpW_totalsLabel",
  "totalsMeta": "_4SDRpW_totalsMeta",
});
